/**
 * Detects if text is SRT (SubRip) format and converts it to LRC format.
 * SRT format:
 *   1
 *   00:00:00,000 --> 00:00:06,780
 *   Welcome to the story.
 *
 *   2
 *   00:00:06,780 --> 00:00:12,500
 *   This is the next line.
 *
 * LRC format:
 *   [00:00.00]Welcome to the story.
 *   [00:06.78]This is the next line.
 */
function convertSrtToLrc(text) {
  if (!text || typeof text !== 'string') return text;

  // Check if text looks like SRT (has --> with comma in timestamp)
  if (!text.includes('-->') || !text.match(/\d{2}:\d{2}:\d{2},\d{3}/)) return text;

  const lines = text.replace(/\r\n/g, '\n').split('\n');
  const result = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i].trim();

    // Skip empty lines
    if (line === '') {
      i++;
      continue;
    }

    // Skip numeric cue identifiers (sequence numbers)
    if (/^\d+$/.test(line)) {
      i++;
      continue;
    }

    // Check for SRT timestamp line: 00:00:00,000 --> 00:00:06,780
    const tsMatch = line.match(/^(\d{2}):(\d{2}):(\d{2}),(\d{3})\s*-->/);
    if (tsMatch) {
      // Parse start time
      const hours = parseInt(tsMatch[1], 10);
      const minutes = parseInt(tsMatch[2], 10) + hours * 60; // Convert hours to minutes
      const seconds = parseInt(tsMatch[3], 10);
      const ms = tsMatch[4].slice(0, 2); // Take first 2 digits for LRC centiseconds

      const lrcTime = `[${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${ms}]`;

      // Collect lyrics text (all lines until next empty line or next timestamp)
      i++;
      const lyricParts = [];
      while (i < lines.length) {
        const nextLine = lines[i].trim();
        // Stop at empty line, next timestamp, or next sequence number
        if (nextLine === '' || 
            nextLine.match(/^\d{2}:\d{2}:\d{2},\d{3}\s*-->/) || 
            /^\d+$/.test(nextLine)) {
          break;
        }
        lyricParts.push(nextLine);
        i++;
      }

      if (lyricParts.length > 0) {
        result.push(lrcTime + lyricParts.join(' '));
      }
    } else {
      i++;
    }
  }

  return result.length > 0 ? result.join('\n') : text;
}

export default convertSrtToLrc;
